/*
 * Copyright (c) 2025 curryfirm.com
 */

import { measureLeg, } from "../helpers.js";

export class WasteRouteOptimizer {
    constructor(start, end, dumpsters, dumps, apiKey) {
        this.start = start;
        this.end = end;
        this.dumpsters = dumpsters;
        this.dumps = dumps;
        // this.start = locationToLatLng(start);
        // this.end = locationToLatLng(end);
        // this.dumpsters = locationToLatLng(dumpsters);
        // this.dumps = locationToLatLng(dumps);
        this.apiKey = apiKey;
        this.timeMatrix = {};
        this.bestRoute = null;
        this.bestTime = Infinity;
        this.steps = {};
    }

    async precomputeTimeMatrix() {
        const allLocations = [
            this.start,
            this.end,
            ...this.dumpsters,
            ...this.dumps
        ];

        for (let i = 0; i < allLocations.length; i++) {
            for (let j = 0; j < allLocations.length; j++) {
                if (i !== j) {
                    const key = `${i}-${j}`;
                    this.timeMatrix[key] = await this.getRouteTime(
                        allLocations[i],
                        allLocations[j]
                    );
                }
            }
        }
    }

    async getRouteTime(origin, destination) {
        const measurement = await measureLeg(origin, destination, null);
        return measurement.durationSeconds;
        // const response = await fetch(
        //     "https://routes.googleapis.com/directions/v2:computeRoutes",
        //     {
        //         method: "POST",
        //         headers: {
        //             'Content-Type': 'application/json',
        //             'X-Goog-Api-Key': this.apiKey,
        //             'X-Goog-FieldMask': 'routes.duration'
        //         },
        //         body: JSON.stringify({
        //             origin: { location: { latLng: origin } },
        //             destination: { location: { latLng: destination } },
        //             travelMode: 'DRIVE',
        //             routingPreference: 'TRAFFIC_AWARE'
        //         })
        //     }
        // );
        //
        // const data = await response.json();
        // return parseFloat(data.routes[0].duration.replace('s', ''));
    }

    getPermutations(arr) {
        if (arr.length <= 1) return [arr];
        const result = [];

        for (let i = 0; i < arr.length; i++) {
            const current = arr[i];
            const remaining = arr.slice(0, i).concat(arr.slice(i + 1));
            const remainingPerms = this.getPermutations(remaining);

            for (const perm of remainingPerms) {
                result.push([current, ...perm]);
            }
        }

        return result;
    }

    calculateRouteTime(dumpsterOrder, dumpAssignments) {
        let totalTime = 0;
        let currentLoc = this.start;

        for (let i = 0; i < dumpsterOrder.length; i++) {
            const dumpsterIdx = dumpsterOrder[i];
            const dumpIdx = dumpAssignments[dumpsterIdx];
            const dumpster = this.dumpsters[dumpsterIdx];
            const dump = this.dumps[dumpIdx];

            totalTime += this.getTime(currentLoc, dumpster);
            totalTime += this.getTime(dumpster, dump);
            totalTime += this.getTime(dump, dumpster);

            currentLoc = dumpster;
        }

        totalTime += this.getTime(currentLoc, this.end);
        return totalTime;
    }

    getTime(loc1, loc2) {
        const allLocs = [this.start, this.end, ...this.dumpsters, ...this.dumps];
        const idx1 = allLocs.findIndex(l =>
            l.lat === loc1.lat && l.lng === loc1.lng
        );
        const idx2 = allLocs.findIndex(l =>
            l.lat === loc2.lat && l.lng === loc2.lng
        );

        return this.timeMatrix[`${idx1}-${idx2}`] || 0;
    }

    findOptimalRoute() {
        const dumpsterIndices = Array.from(
            { length: this.dumpsters.length },
            (_, i) => i
        );

        const dumpsterPermutations = this.getPermutations(dumpsterIndices);
        const dumpCombinations = this.generateDumpAssignments(
            this.dumpsters.length,
            this.dumps.length
        );

        for (const dumpsterOrder of dumpsterPermutations) {
            for (const dumpAssignment of dumpCombinations) {
                const time = this.calculateRouteTime(dumpsterOrder, dumpAssignment);

                if (time < this.bestTime) {
                    this.bestTime = time;
                    this.bestRoute = {
                        dumpsterOrder,
                        dumpAssignment,
                        totalTime: time
                    };
                }
            }
        }

        return this.bestRoute;
    }

    generateDumpAssignments(numDumpsters, numDumps) {
        const result = [];

        function generate(current, depth) {
            if (depth === numDumpsters) {
                result.push([...current]);
                return;
            }

            for (let dumpIdx = 0; dumpIdx < numDumps; dumpIdx++) {
                current[depth] = dumpIdx;
                generate(current, depth + 1);
            }
        }

        generate(new Array(numDumpsters), 0);
        return result;
    }

    getRouteSequence() {
        if (!this.bestRoute) return null;

        const sequence = [this.start];
        const { dumpsterOrder, dumpAssignment } = this.bestRoute;

        for (const dumpsterIdx of dumpsterOrder) {
            const dumpster = this.dumpsters[dumpsterIdx];
            const dump = this.dumps[dumpAssignment[dumpsterIdx]];

            sequence.push(dumpster);
            sequence.push(dump);
            sequence.push(dumpster);
        }

        sequence.push(this.end);
        return sequence;
    }
}
